import React from "react";

export default function CarouselIndicators() {
  return (
    <>
      <div className="carousel-indicators">
        {["city", "building", "calendar-plus", "coins", "heading", "handshake", "table-list", "list-check"].map((icon, index) => (
          <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={`position-relative ${index === 0 ? "active" : ""}`} aria-current={index === 0} aria-label={`Slide ${index + 1}`}>
            <div className="rounded-5 bg-100 position-absolute top-50 start-0 translate-middle d-flex justify-content-center align-items-center">
              <i className={`fa-solid fa-${icon}`}></i>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
